
import { Component, Vue, Prop } from "vue-property-decorator";
import { LocationData } from '@/types/locations';
import IButton from '@/ui-components/IButton/IButton.vue';
import LocationSelects from '@/pages/shared/CampaignWizard/components/Locations/components/LocationSelects.vue';


@Component({
  components: {
    IButton,
    LocationSelects,
    }
})
export default class LocationFilters extends Vue {
  @Prop({ required: true, default: () => [] }) locations!: LocationData[];
  public sheet: boolean = false;

  clearFilters(){
    const locationSelects = this.$refs.locationSelects as LocationSelects;
    const locationSelectsResponsive = this.$refs.locationSelectsResponsive as LocationSelects;
    locationSelects.clearAllFilters()
    locationSelectsResponsive.clearAllFilters();
    const { lang } = this.$route.query;

    this.$router.replace({
      path: this.$route.path,
      query: lang ? { lang } : {}
    }).catch(() => {
    });
  }
}
